export enum SavedViewsPopoverBlock {
  Root = 'ViewToolbarSavedViewsPopover',
}

export enum SavedFiltersPopoverElement {
  SavedViews = 'savedViews',
}
